module.exports = __webpack_public_path__ + "static/media/img_mausoleo.2b923a12.jpg";